var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-comments-area" }, [
    _c("div", { staticClass: "go-block-header" }, [
      _c("div", { staticClass: "chat-input-wrap" }, [
        _c("textarea", {
          attrs: {
            id: "autoResizeTextarea",
            rows: "1",
            maxlength: "3000",
            placeholder: _vm.isReply
              ? _vm.t("briefing.comment.replyPlaceHolder")
              : _vm.t("briefing.comment.createPlaceHolder"),
          },
          on: { input: _vm.autoResize, change: _vm.onChangeComment },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "go-block-body" }, [
      _c(
        "ul",
        { staticClass: "go-comments-attach files" },
        _vm._l(_vm.files, function (file, index) {
          return _c("li", { key: index }, [
            _c("div", [
              _c("p", [
                file &&
                ((file.contentType && file.contentType.includes("pdf")) ||
                  (file.type && file.type.includes("pdf")))
                  ? _c("img", {
                      attrs: {
                        src: "/content/images/images_v4/common/go-icon-document/file-pdf-fill.svg",
                        alt: "PDF Icon",
                      },
                    })
                  : file &&
                    ((file.contentType &&
                      file.contentType.includes(".document")) ||
                      (file.type && file.type.includes(".document")))
                  ? _c("img", {
                      attrs: {
                        src: "/content/images/images_v4/common/go-icon-document/file-word-fill.svg",
                        alt: "Word Icon",
                      },
                    })
                  : file &&
                    ((file.contentType &&
                      file.contentType.includes(".sheet")) ||
                      (file.type && file.type.includes(".sheet")))
                  ? _c("img", {
                      attrs: {
                        src: "/content/images/images_v4/common/go-icon-document/file-excel-fill.svg",
                        alt: "Excel Icon",
                      },
                    })
                  : _c("img", {
                      attrs: {
                        src: "/content/images/DOCUMENT.png",
                        alt: "default",
                      },
                    }),
              ]),
              _vm._v(" "),
              _c("a", { attrs: { href: "#" } }, [_vm._v(_vm._s(file.name))]),
              _vm._v(" "),
              _c("ins", [
                _vm._v(
                  "." +
                    _vm._s(
                      file.name.split(".")[file.name.split(".").length - 1]
                    )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("small", [_vm._v(_vm._s(_vm.formatSize(file.size)))]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-default",
                on: {
                  click: function ($event) {
                    return _vm.removeFile(index)
                  },
                },
              },
              [_c("i", { staticClass: "go-icon-14 go-icon-close" })]
            ),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "go-comments-attach images" },
        _vm._l(_vm.images, function (image, index) {
          return _c("li", { key: index }, [
            _c("p", [
              _c("img", { attrs: { src: image.url, alt: "Uploaded Image" } }),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-default",
                on: {
                  click: function ($event) {
                    return _vm.removeImage(index)
                  },
                },
              },
              [_c("i", { staticClass: "go-icon-14 go-icon-close" })]
            ),
          ])
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "go-block-footer" }, [
      _c("div", { staticClass: "go-block-between" }, [
        _c("div", [
          _c("input", {
            ref: "fileInputRef",
            staticStyle: { display: "none" },
            attrs: {
              accept: ".pdf,.docx,.pptx,.xlsx",
              type: "file",
              multiple: "",
            },
            on: { change: _vm.handleFileUpload },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn go-btn-icon",
              on: {
                click: function ($event) {
                  return _vm.triggerFileInput(1)
                },
              },
            },
            [_c("i", { staticClass: "go-icon-22 go-icon-file-upload" })]
          ),
          _vm._v(" "),
          _c("input", {
            ref: "imageInputRef",
            staticStyle: { display: "none" },
            attrs: { accept: ".jpg,.jpeg,.png", type: "file", multiple: "" },
            on: { change: _vm.handleFileUpload },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn go-btn-icon",
              on: {
                click: function ($event) {
                  return _vm.triggerFileInput(0)
                },
              },
            },
            [_c("i", { staticClass: "go-icon-22 go-icon-photo-up" })]
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "custom-control custom-checkbox" }, [
            _c("input", {
              staticClass: "custom-control-input",
              attrs: {
                id: "customCheckDisabled" + _vm.checkbox,
                type: "checkbox",
              },
              on: { change: _vm.onChangePrivate },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "custom-control-label",
                attrs: { for: "customCheckDisabled" + _vm.checkbox },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.t("briefing.comment.private")) +
                    "\n          "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn go-btn-primary go-btn-lg",
              on: { click: _vm.onSubmitComment },
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.t("briefing.comment.submit")) +
                  "\n        "
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }